/**
 * @deprecated This file is deprecated and will be removed in a future version.
 * Please use the services.ts function instead.
 * See src/services/* for the new implementation.
 */

import axios, { InternalAxiosRequestConfig } from 'axios'

import { AuthUser } from '../models'
import config from '../config'
import { customLogger } from '../plugins/sentry/customLogger'
import firebase from 'firebase/compat/app'
import store from '../store'

const getAPIKey = async () => {
  const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
  return 'Bearer ' + auth.apiKey
}

const getFirebaseToken = () => {
  const token = firebase?.auth()?.currentUser?.getIdToken()
  if (!token) {
    // TODO: This will never load as token is a promise.
    customLogger({indexName: 'firebase-token-issues', message: `Issue while getting firebase token`, level: 'info', tags: {
      file: 'axios_interceptors.ts'
    }})
  }
  return token
}

const defaultInterceptor = async (requestConfig: InternalAxiosRequestConfig) => {
  try {
    requestConfig.headers.authorization = await getAPIKey()
  } catch (e) {
    console.error('defaultInterceptor error: ', e)
  }
  return requestConfig
}

const interceptorWithFirebaseOnly = async (
  requestConfig: InternalAxiosRequestConfig
) => {
  try {
    requestConfig.headers.authorization = 'Bearer ' + (await getFirebaseToken())
  } catch (e) {
    console.error('interceptorWithFirebaseOnly error: ', e)
  }
  return requestConfig
}

const interceptorWithBothTokenV2 = async (
  requestConfig: InternalAxiosRequestConfig
) => {
  try {
    requestConfig.headers.authorization = await getAPIKey()
    requestConfig.headers['token-id'] = await getFirebaseToken()
  } catch (e) {
    console.error('interceptorWithBothTokenV2 error: ', e)
  }
  return requestConfig
}

const interceptorWithTokenV2 = async (
  requestConfig: InternalAxiosRequestConfig
) => {
  try {
    requestConfig.headers.authorization = `Bearer ${await window.getAuthToken(true)}`
    requestConfig.headers.source = 'WEB_USER'
    requestConfig.headers.channel = 'APP'
    requestConfig.headers.version = '2021-07-28'
  } catch (e) {
    console.error('interceptorWithBothTokenV2 error: ', e)
  }
  return requestConfig
}

export const interceptorWithBothToken = async (
  requestConfig: InternalAxiosRequestConfig
) => {
  try {
    requestConfig.headers.authorization = await getAPIKey()
    if (!requestConfig?.url?.includes('algolia')) {
      requestConfig.headers['token-id'] = await getFirebaseToken()
    }
  } catch (e) {
    console.error('interceptorWithBothToken error: ', e)
  }
  return requestConfig
}

const interceptorWithTokenIdOnly = async (
  requestConfig: InternalAxiosRequestConfig
) => {
  try {
    requestConfig.headers['token-id'] = await getFirebaseToken()
  } catch (e) {
    console.error('interceptorWithTokenIdOnly error: ', e)
  }
  return requestConfig
}

export const pythonBackend = axios.create({
  baseURL: config.pythonBaseUrl,
})
pythonBackend.interceptors.request.use(defaultInterceptor)

export const membershipBackend = axios.create({
  baseURL: config.membershipUrl,
})
membershipBackend.interceptors.request.use(interceptorWithFirebaseOnly)

export const snapshotBackend = axios.create({
  baseURL: config.snapshotServiceUrl,
})
snapshotBackend.interceptors.request.use(interceptorWithTokenV2)

export const dialogflowEngagements = axios.create({
  baseURL: config.dialogflowEngagementsBaseUrl,
})
dialogflowEngagements.interceptors.request.use(defaultInterceptor)

export const paymentService = axios.create({
  baseURL: config.paymentServiceBaseUrl,
})
paymentService.interceptors.request.use(defaultInterceptor)

export const publicApi = axios.create({
  baseURL: config.publicApiUrl,
})
publicApi.interceptors.request.use(interceptorWithFirebaseOnly)

export const saasService = axios.create({
  baseURL: config.saasServiceBaseUrl,
})
saasService.interceptors.request.use(interceptorWithBothTokenV2)
export const isvService = axios.create({
  baseURL: config.isvServiceBaseUrl,
})
isvService.interceptors.request.use(interceptorWithBothTokenV2)

export const humanRollOverService = axios.create({
  baseURL: config.humanRollOverServiceBaseUrl,
})
humanRollOverService.interceptors.request.use(defaultInterceptor)

export const appengineBackend = axios.create({
  baseURL: config.newBaseUrl,
})
appengineBackend.interceptors.request.use(interceptorWithTokenV2)

export const snapshotsRevexService = axios.create({
  baseURL: config.snapshotsRevexUrl,
  headers: {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28'
  }
})
snapshotsRevexService.interceptors.request.use(interceptorWithTokenIdOnly)


export const revexBackendService = axios.create({
  baseURL: config.ghlRevexBackendUrl,
  headers: {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28'
  }
})
revexBackendService.interceptors.request.use(interceptorWithTokenIdOnly)

export const emailBackend = axios.create({
  baseURL: config.emailsServiceUrl,
  headers: {
    channel: 'APP',
    source: 'WEB_USER',
    version: '2021-07-28'
  }
})

emailBackend.interceptors.request.use(interceptorWithTokenIdOnly)
